import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * `tailwind-merge`, taught the project's own type scale.
 *
 * Out of the box it reads any `text-*` it does not recognise as a text
 * *colour*. So `text-caption` (a font size declared in `index.css`) and
 * `text-emerald-700` looked like two colours fighting, and whichever came
 * second deleted the other: every `Badge` lost its size and rendered at body
 * size, and every `text-ink-muted text-caption` label lost its muted colour.
 * Declaring the sizes as sizes stops the merge treating them as rivals.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['caption', 'body', 'title', 'display'] }],
    },
  },
});

/** Merge conditional class names, resolving conflicting Tailwind utilities. */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
